import dayjs, { type Dayjs } from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import utc from 'dayjs/plugin/utc';
import 'dayjs/locale/hu';
import 'dayjs/locale/ro';

dayjs.extend(customParseFormat);
dayjs.extend(localizedFormat);
dayjs.extend(utc);

export type { Dayjs };

export default dayjs;

/** Parse a value for pickers/display; returns null when missing or invalid. */
export function toDayjs(value: unknown): Dayjs | null {
  if (value == null) {
    return null;
  }
  const parsed = dayjs(value as dayjs.ConfigType);
  return parsed.isValid() ? parsed : null;
}
